import React from 'react'

import Swiper from 'react-id-swiper'

import CarouselItem from './CarouselItem'

const params = {
  pagination: {
    el: '.swiper-pagination',
    type: 'bullets',
    clickable: true
  },
  autoplay: {
    delay: 8000,
  },
}

const Carousel = ({ data }) => {
  return (
    <>
      <Swiper className="swiper-wrapper" {...params}>
          {data.map(item => (
            <CarouselItem key={item.id} item={item.primary} />
          ))}
      </Swiper>
    </>
  )
}

export default Carousel
